import React, { memo, useCallback } from 'react';

const ActionButton = memo(({ 
    text, 
    targetId, 
    className = '', 
    onClick, 
    Icon, 
    iconPlacement = 'left', 
}) => {
    
    const handleClick = useCallback(() => {
        if (onClick) {
            onClick();
        } else if (targetId) {
            const targetSection = document.getElementById(targetId);
            if (targetSection) {
                targetSection.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [targetId, onClick]);

    const isSecondaryOutline = className.includes('btn-secondary-outline');
    const baseClass = isSecondaryOutline 
        ? 'btn-secondary-outline' 
        : 'btn-primary-gradient';

    const renderIcon = () => {
        if (!Icon) return null;
        
        const marginClass = text ? (iconPlacement === 'left' ? 'mr-2' : 'ml-2') : '';
        
        return <Icon size={18} className={marginClass} />; 
    };

    return (
        <button
            className={`
                ${baseClass} 
                btn-lg 
                ${className} 
                shadow-lg 
                ${Icon ? 'flex items-center justify-center' : ''} 
            `}
            onClick={handleClick}
        >
            {Icon ? (
                <span className="flex items-center justify-center">
                    {iconPlacement === 'left' && renderIcon()}
                    {text}
                    {iconPlacement === 'right' && renderIcon()}
                </span>
            ) : (
                <>{text}</>
            )}
        </button>
    );
});

ActionButton.displayName = 'ActionButton';

export default ActionButton;